import { PostRequest, successParam } from '@/api/base';

export function addThirdPartDevice(params: object, callback: successParam) {
    PostRequest('v3/web/single/thirdPartDevice/add', params, callback);
}

export function editThirdPartDevice(params: object, callback: successParam) {
    PostRequest('v3/web/single/thirdPartDevice/edit', params, callback);
}